/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Title_TailInputs */

const en_landing_how_title_tail = /** @type {(inputs: Landing_How_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to the gym floor.`)
};

const pl_landing_how_title_tail = /** @type {(inputs: Landing_How_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i jesteś na sali.`)
};

/**
* | output |
* | --- |
* | "to the gym floor." |
*
* @param {Landing_How_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_title_tail = /** @type {((inputs?: Landing_How_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_title_tail(inputs)
	return en_landing_how_title_tail(inputs)
});